import { Link } from "react-router-dom";
import HeaderBis from "../components/layout/headerbis";
import backgroundPack from "../assets/img/header1.webp";
import BasicPackRond from "../assets/img/basicpack.webp";
import BasicPackOvale from "../assets/img/basicpack.webp";
import IcePack from "../assets/img/icetank.webp";
import BaignoirePackRond from "../assets/img/baignoire.webp";
import BaignoirePackOvale from "../assets/img/baignoire.webp";
import PackConfortRond from "../assets/img/confortpack.webp";
import PackConfortOvale from "../assets/img/confortpack.webp";
import HotTubPackRond from "../assets/img/hotspring.webp";
import HotTubPackOvale from "../assets/img/hotspring.webp";
import PremiumPackRond from "../assets/img/jacuzzi.webp";
import HotSpringSummerPackRond from "../assets/img/hottub.webp";

export const stockTanksData = [
  {
    name: "Basic Pack",
    url: "BasicPack",
    description:
      "→ Groupe de Filtration Poolex 3m³/heure (Filtre + Pompe) → Masse Filtrante Pureflow pour filtre à sable 130g → Tuyau Souple Ø 38 → Traversée de Paroi x2 → Trous Pré-Percés → Doseur Flottant pour Chlore → Thermomètre de Piscine",
    variants: {
      rond: {
        image: BasicPackRond,
        sizes: [
          { taille: "244 cm", prix: "1830 €" },
          { taille: "213 cm", prix: "1615 €" },
          { taille: "183 cm", prix: "1451 €" },
        ],
      },
      ovale: {
        image: BasicPackOvale,
        sizes: [
          { taille: "244x91 cm", prix: "1347 €" },
          { taille: "213x76 cm", prix: "1158 €" },
          { taille: "183x76 cm", prix: "1093 €" },
          { taille: "183x61 cm", prix: "857 €" },
        ],
      },
    },
  },
  {
    name: "Ice Tank Ovale | Bain Froid",
    url: "IcePack",
    image: IcePack,
    description:
      "→ Groupe de Filtration Poolex 3m³/heure (Filtre + Pompe) → Pompe à Chaleur → Masse Filtrante Pureflow pour filtre à sable 130g → Tuyau Souple Ø 38 → Traversée de Paroi x2 | Trous Pré-Percés → Doseur Flottant pour Chlore | Thermomètre de Piscine",
    sizes: [
      { taille: "213x76 cm", prix: "1970 €" },
      { taille: "183x76 cm", prix: "1900 €" },
      { taille: "152x61 cm", prix: "1700 €" },
      { taille: "122x61 cm", prix: "1620 €" },
      { taille: "91x61 cm", prix: "1600 €" },
    ],
  },

  {
    name: "Baignoire Pack",
    url: "BaignoirePack",
    description:
      "→ Baignoire prête à installer, livrée avec le tank et bonde d'évacuation incluse. Solution complète facilitant l’installation, conçue pour assurer une évacuation efficace et une mise en service rapide.",
    variants: {
      rond: {
        image: BaignoirePackRond,
        sizes: [
          { taille: "244 cm", prix: "2330 €" },
          { taille: "213 cm", prix: "2150 €" },
          { taille: "183 cm", prix: "2035 €" },
          { taille: "152 cm", prix: "1900 €" },
        ],
      },
      ovale: {
        image: BaignoirePackOvale,
        sizes: [
          { taille: "244x91 cm", prix: "2330 €" },
          { taille: "213x76 cm", prix: "2150 €" },
          { taille: "183x76 cm", prix: "2035 €" },
          { taille: "152x61 cm", prix: "1900 €" },
        ],
      },
    },
  },

  {
    name: "Pack Confort",
    url: "PackConfort",
    description:
      "→ Groupe de Filtration Poolex 3m³/heure (Filtre + Pompe) → Masse Filtrante Pureflow pour filtre à sable 130g → Pompe à Chaleur Réverssible 3kw (5kw ou 7kw sur devis) → Traversée de Paroi x2 → Trous Pré-Percés | Tuyau Souple Ø 38 → Doseur Flottant pour Chlore → Thermomètre de Piscine | Aspirateur de Piscine Vektro Mini",
    variants: {
      rond: {
        image: PackConfortRond,
        sizes: [
          { taille: "244 cm", prix: "2551 €" },
          { taille: "213 cm", prix: "2345 €" },
          { taille: "183 cm", prix: "2175 €" },
        ],
      },
      ovale: {
        image: PackConfortOvale,
        sizes: [
          { taille: "244x91 cm", prix: "1347 €" },
          { taille: "213x76 cm", prix: "1158 €" },
          { taille: "183x76 cm", prix: "1093 €" },
          { taille: "183x61 cm", prix: "857 €" },
        ],
      },
    },
  },

  {
    name: "Hot Tub Pack",
    url: "HotTubPack",
    description:
      "→ Groupe de Filtration Poolex 3m³/heure (Filtre + Pompe) → Masse Filtrante Pureflow pour filtre à sable 130g → Poêle à bois Firebox 22kw  → Kit de Raccordement du Poêle → Tuyau Souple Ø 38 → Traversée de Paroi x2 | Trous Pré-Percés → Doseur Flottant pour Chlore | Thermomètre de Piscine ",
    variants: {
      rond: {
        image: HotTubPackRond,
        sizes: [
          { taille: "183 cm", prix: "2550 €" },
          { taille: "152 cm", prix: "2310 €" },
        ],
      },
      ovale: {
        image: HotTubPackOvale,
        sizes: [
          { taille: "244x91 cm", prix: "2330 €" },
          { taille: "213x76 cm", prix: "2150 €" },
          { taille: "183x76 cm", prix: "2035 €" },
          { taille: "152x61 cm", prix: "1900 €" },
        ],
      },
    },
  },

  {
    name: "Pack Jaccuzi",
    url: "PremiumPackRond",
    image: PremiumPackRond,
    description:
      "→ Groupe de Filtration Poolex 3m³/heure (Filtre + Pompe) → Masse Filtrante Pureflow pour filtre à sable 130g → 4 jets Air/Eau | Pompe de massage → Traversée de Paroi x2 → Trous Pré-Percés | Tuyau Souple Ø 38 → Doseur Flottant pour Chlore → Thermomètre de Piscine → Possibilité d'ajouter une Pompe à Chaleur Réversible 3kw, 5kw ou 7kw ou un poêle à bois sur devis",
    sizes: [
      { taille: "244 cm", prix: "2350 €" },
      { taille: "213 cm", prix: "2100 €" },
      { taille: "183 cm", prix: "1990 €" },
    ],
  },

  {
    name: "Hot Spring Summer Pack Rond",
    url: "HotSpringSummerPack",
    image: HotSpringSummerPackRond,
    description:
      "→ Groupe de Filtration Poolex 3m³/heure (Filtre + Pompe) → Masse Filtrante Pureflow pour filtre à sable 130g → Poêle à bois 39kw → Kit de Raccordement du Poêle → Tuyau Souple Ø 38 → Traversée de Paroi x2 | Trous Pré-Percés → Doseur Flottant pour Chlore → Thermomètre de Piscine",
    sizes: [
      { taille: "244 cm", prix: "3374 €" },
      { taille: "213 cm", prix: "2919 €" },
      { taille: "183 cm", prix: "2750 €" },
    ],
  },
];

export default function StockTanksPage() {
  return (
    <div>
      <HeaderBis
        backgroundImage={backgroundPack}
        title="TANKKD"
        desc="Nos Packs Stock Tanks Ronds et Ovales"
      />
      <div className="container mx-auto pt-20 pb-20 px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stockTanksData.map((tank) => {
            const imageSrc =
              tank.variants?.rond?.image ||
              tank.variants?.ovale?.image ||
              tank.image;

            return (
              <div
                key={tank.url}
                className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-lg transition"
              >
                <img
                  src={imageSrc}
                  alt={tank.name}
                  className="w-full h-56 object-cover"
                />
                <div className="p-4 flex items-center justify-center text-center flex-col">
                  <h2 className="text-xl font-semibold mb-1">{tank.name}</h2>
                  <Link
                    to={`/produit/${encodeURIComponent(tank.url)}`}
                    className="flex w-40 items-center justify-center text-center mt-2 bg-[#005478] border border-[#005478] text-white py-2 rounded-full hover:bg-[#ffffff] hover:text-[#005478] transition"
                  >
                    Voir le produit
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}